'use client'

import { SearchSection } from '@features/algolia.components/src/SearchSection'
import { Footer } from '@features/common.components/Footer'
import { Header } from '@features/common.components/Header'
import DOMPurify from 'isomorphic-dompurify'
import Image from 'next/image'
import { useSearchParams } from 'next/navigation'
import useTranslation from 'next-translate/useTranslation'

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation('common')
  const searchParams = useSearchParams()
  const searchTerm = DOMPurify.sanitize(
    searchParams.get('search') ?? '',
  ).replaceAll(/[/-]/g, ' ')
  return (
    <>
      <Header enableScrollIndicator={false} />
      <main className="mx-auto mt-header min-h-[80vh] w-full max-w-[1145px] overflow-x-hidden px-6 pb-4 pt-8">
        <div className="flex flex-col sm:flex-row">
          <section>
            <div className="flex flex-col gap-3 pb-12 pt-7">
              <h2 className="text-neutral-strong type-h-page-md">
                {t('notFound.title')}
              </h2>
              <p className="text-neutral-subtle type-intro-md">
                {t('notFound.subtitle')}
              </p>
            </div>
            <div className="sm:w-[606px]">
              <SearchSection searchTerm={searchTerm} />
            </div>
          </section>
          <aside className="hidden w-[432px] overflow-hidden sm:block">
            <Image
              alt={t('homePage.joinCommunity.followUs.twitter.label')}
              className="max-w-[432px] pt-36"
              height={432}
              src="/images/PartnershipCommunity.png"
              width={432}
            />
          </aside>
        </div>
      </main>
      <Footer />
    </>
  )
}
